
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { AppRoutes } from "@/components/routing/AppRoutes";
import { HelmetProvider } from "react-helmet-async";
import { OrganizationSchema } from "@/components/SEOStructuredData";
import { queryClient } from "@/lib/react-query";
import FloatingChatButton from "@/components/FloatingChatButton";

function App() {
  console.log("[App] Rendering App component");
  
  return (
    <React.StrictMode>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <Router>
            <OrganizationSchema />
            <AppRoutes />
            <FloatingChatButton />
            <Toaster />
          </Router>
        </QueryClientProvider>
      </HelmetProvider>
    </React.StrictMode>
  );
}

export default App;
